module.exports = __webpack_public_path__ + "img/GAME_QUIZ1.e459cb27.jpg";